export const stickyPadding = { xs: 1, sm: 2, md: 3 };
export const mainPadding = { xs: 1, md: 2 };
export const containerPadding = 2;
export const innerPadding = 1;
export const containerSpacing = 3;
export const innerSpacing = 2;
